import { FsLightbox } from 'fslightbox'
// require('fslightbox');

class ModalVideo {
  constructor(el) {
    this.dom = {el: el};

    this.init();
  }

  init() {
  }
}

export default ModalVideo